import { config } from '@app/config';

import { BRAND_ASSETS_BASE } from '../../constants';

interface Props {
  className?: string;
  collapsed: boolean;
}

export const Brand = (props: Props) => {
  return (
    <img
      className={props.className}
      src={
        props.collapsed
          ? `${BRAND_ASSETS_BASE}/images/brand-mini.png`
          : `${BRAND_ASSETS_BASE}/images/brand.png`
      }
      alt="MediaInbox brand"
      style={config.isAppDev ? { filter: 'hue-rotate(180deg) saturate(1.5)' } : undefined}
    />
  );
};
